import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        color: "#353535",
        fontSize: "16px",
        letterSpacing: 0,
        textDecoration: "underline",
        cursor: "pointer",
        userSelect: "none",
    },

    bold_container: {
        color: "#353535",
        fontSize: "16px",
        letterSpacing: 0,
        textDecoration: "underline",
        cursor: "pointer",
        fontWeight: "bold",
        userSelect: "none",
    },

    disabled: {
        color: "#353535",
        fontSize: "16px",
        letterSpacing: 0,
        textDecoration: "underline",
        cursor: "auto",
        opacity: 0.4,
        userSelect: "none",
    },
}));

export default useStyles;
